export var SECURITY_OPTION_REPOSITORY = 'SECURITY_OPTION_REPOSITORY';